var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-layout-type',{attrs:{"data-source":'tecpage.user.modules.' + _vm.moduleId + '.layout.type',"options":_vm.getActiveModuleLayoutTypes,"data-default":{ type: 'first' }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }